import { BmsCustomer } from '../../features/bms/models/bms-customer';
import { Customer, GrpcNode } from '@xprojectorcore/xprojector_backend/proto/xprojector.grpc.models.pb';

export class BmsDataCollectorViewData {
  public node : GrpcNode;
  public customer : Customer;
  public bmsCustomer : BmsCustomer;
  public width : number;
}
